// Gallery collection for the full-screen Lightbox.
//
// Each thumbnail resolves its own object-URL via useAuthedImageUrl (hooks can't
// run inside a .map), so the parent bubble never holds the resolved list. Rather
// than plumb that state up through both bubbles, each rendered thumbnail tags
// itself with data-lb-src / data-lb-name and its container is marked
// [data-lb-group]. At click time we read the group in DOM order — which is
// exactly the set of images the user can actually see in that message.

export interface LbImage {
  blobUrl: string;
  filename?: string;
}

/**
 * Collect every lightbox-able image inside the clicked element's nearest
 * [data-lb-group] ancestor, in DOM order, plus the index of the clicked one.
 * Falls back to a single-item gallery when there's no group (or nothing tagged).
 */
export function collectGallery(el: HTMLElement, self: LbImage): { items: LbImage[]; index: number } {
  const group = el.closest<HTMLElement>("[data-lb-group]");
  if (!group) return { items: [self], index: 0 };

  const items = Array.from(group.querySelectorAll<HTMLImageElement>("img[data-lb-src]"))
    .map((n) => ({ blobUrl: n.dataset.lbSrc!, filename: n.dataset.lbName || undefined }))
    .filter((i) => !!i.blobUrl);

  if (items.length === 0) return { items: [self], index: 0 };

  const index = items.findIndex((i) => i.blobUrl === self.blobUrl);
  return { items, index: index < 0 ? 0 : index };
}
